/* eslint-disable no-console */

/**
 * Greets the user by printing a message in the console.
 * @param name The user's name.
 */
export const showVersion = (version: string) => {
  console.log(`Version: ${version}!`);
};
